import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e043cdb0&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=e043cdb0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e043cdb0",
  null
  
)

export default component.exports